import type { Dictionnaire } from '../type';

export const commun: Dictionnaire['commun'] = {
  annuler: 'إلغاء',
  oui: 'نعم',
  actions: 'إجراءات',
  confirmer: 'تأكيد',
  retour: 'رجوع',
  reessayer: 'إعادة المحاولة',
  pleinEcran: 'الصورة بملء الشاشة',
  fermer: 'إغلاق',
  enLigne: 'متصل',
  erreur: 'حدث خطأ ما',
  serveur: {
    refuse: 'هذه الرسالة لا تحترم قواعد المجتمع.',
    invalide: 'رسالة غير صالحة',
    accesRefuse: 'تم رفض الوصول.',
    indisponible: 'تعذّر النشر حاليًا. أعد المحاولة بعد قليل.',
  },
  choisisUnSpot: 'اختر مدينة أولًا',
  membreInconnu: 'عضو غير معروف',
  quelquun: 'شخص ما',
  nonConfigure: 'لم يتم إعداد Firebase. املأ client/.env.local (راجع client/.env.example).',
  unInstant: 'لحظة…',
  envoi: 'جارٍ الإرسال…',
  uneLangue: 'اختر لغة واحدة على الأقل.',
};
